if (!customElements.get('pickup-availability')) {
  customElements.define(
    'pickup-availability',
    class PickupAvailability extends HTMLElement {
      constructor() {
        super();

        this.errorHtml = this.querySelector('template').content.firstElementChild.cloneNode(true);
        this.onClickRefreshList = this.onClickRefreshList.bind(this);
        this.onClickShowDrawer = this.onClickShowDrawer.bind(this);
        this.requestId = 0;
        this.fetchAvailability(this.dataset.variantId);
      }

      clearDrawer() {
        const drawer = document.querySelector('pickup-availability-drawer');
        if (drawer?.hasAttribute('open')) drawer.hide();
        drawer?.remove();
      }

      setAlternateButton(loading = false) {
        const button = document.querySelector('#ShowPickupAvailabilityDrawerAlternate');
        if (!button) return;
        button.disabled = loading;
        button.setAttribute('aria-busy', String(loading));
        button.removeEventListener('click', this.onClickShowDrawer);
        button.addEventListener('click', this.onClickShowDrawer);
      }

      onClickShowDrawer(event) {
        const drawer = document.querySelector('pickup-availability-drawer');
        if (drawer) drawer.show(event.currentTarget);
        else this.onClickRefreshList();
      }

      fetchAvailability(variantId) {
        if (!variantId) return;

        this.dataset.variantId = variantId;
        const requestId = ++this.requestId;
        // Clear the previous variant before loading, including failed requests.
        this.clearDrawer();
        this.setAlternateButton(true);
        let rootUrl = this.dataset.rootUrl;
        if (!rootUrl.endsWith('/')) rootUrl += '/';
        const variantSectionUrl = `${rootUrl}variants/${variantId}/?section_id=pickup-availability`;

        return fetch(variantSectionUrl)
          .then((response) => {
            if (!response.ok) throw new Error('Pickup availability request failed');
            return response.text();
          })
          .then((text) => {
            if (requestId !== this.requestId) return;
            const sectionInnerHTML = new DOMParser()
              .parseFromString(text, 'text/html')
              .querySelector('.shopify-section');
            this.renderPreview(sectionInnerHTML);
          })
          .catch(() => {
            if (requestId === this.requestId) this.renderError();
          })
          .finally(() => {
            if (requestId === this.requestId) this.setAlternateButton();
          });
      }

      onClickRefreshList() {
        return this.fetchAvailability(this.dataset.variantId);
      }

      update(variant) {
        if (variant?.id) {
          return this.fetchAvailability(variant.id);
        }
        ++this.requestId;
        this.clearDrawer();
        this.setAlternateButton(true);
        this.removeAttribute('available');
        this.innerHTML = '';
      }

      renderError() {
        this.clearDrawer();
        this.replaceChildren(this.errorHtml.cloneNode(true));
        this.querySelector('button').addEventListener('click', this.onClickRefreshList);
      }

      renderPreview(sectionInnerHTML) {
        this.clearDrawer();
        const preview = sectionInnerHTML?.querySelector('pickup-availability-preview');
        const drawer = sectionInnerHTML?.querySelector('pickup-availability-drawer');
        if (!preview || !drawer) {
          this.renderError();
          return;
        }

        this.innerHTML = preview.outerHTML;
        this.setAttribute('available', '');
        document.body.appendChild(drawer);
        const colorClassesToApply = (this.dataset.productPageColorScheme || '').split(' ').filter(Boolean);
        colorClassesToApply.forEach((colorClass) => drawer.classList.add(colorClass));

        this.querySelector('button')?.addEventListener('click', this.onClickShowDrawer);
      }
    }
  );
}

if (!customElements.get('pickup-availability-drawer')) {
  customElements.define(
    'pickup-availability-drawer',
    class PickupAvailabilityDrawer extends HTMLElement {
      constructor() {
        super();

        this.onBodyClick = this.handleBodyClick.bind(this);

        this.querySelector('button').addEventListener('click', () => {
          this.hide();
        });

        this.addEventListener('keyup', (event) => {
          if (event.code.toUpperCase() === 'ESCAPE') this.hide();
        });
      }

      handleBodyClick(evt) {
        const target = evt.target;
        if (
          target != this &&
          !target.closest('pickup-availability-drawer') &&
          target.id != 'ShowPickupAvailabilityDrawer'
        ) {
          if (target.id != 'ShowPickupAvailabilityDrawerAlternate') {
            this.hide();
          }
        }
      }

      hide() {
        this.removeAttribute('open');
        document.body.removeEventListener('click', this.onBodyClick);
        document.body.classList.remove('overflow-hidden');
        removeTrapFocus(this.focusElement);
      }

      show(focusElement) {
        this.focusElement = focusElement;
        this.setAttribute('open', '');
        document.body.addEventListener('click', this.onBodyClick);
        document.body.classList.add('overflow-hidden');
        trapFocus(this);
      }
    }
  );
}
